import axios from "axios";
import { getInstance } from "./orm";
import { baseUrl } from "@/config/baseUrl";

export const init = async ({ option_id, app_name, model_name, default_conds }) => {
    let config = {};
    config.appName = app_name;
    config.modelName = model_name;
    config.orm = getInstance({ app_name: config.appName, model_name: config.modelName })
    config.defaultConds = default_conds;
    config.loading = false;
    config.option = null;
    config.data = [];
    config.selectedRows = null;
    let pager = {
        background: true,
        pageSizes: [5, 10, 20, 30, 40, 50, 100],
        pagerCount: 7,
        currentPage: 1,
        total: 10,
        pageSize: 10,
    };
    config.pager = new Proxy(pager, {
        set(target, key, value) {
            console.log('pager', key, value);
            if (target[key] != value) {
                setTimeout(config.refresh, 1);
            }
            return Reflect.set(target, key, value);
        }
    });
    let conds = {
        searcher: [],
        date: [],
        filter: [],
        order: null
    };
    config.conds = new Proxy(conds, {
        async set(target, key, value) {
            if (target[key] != value) {
                setTimeout(config.refresh, 1);
            }
            return Reflect.set(target, key, value);
        }
    });
    let opt = await axios.post(
        `${baseUrl}/avue/avue_table/find?id=` + option_id, {}
    );
    config.option = JSON.parse(opt.data.data.content)
    config.refresh = async () => {
        config.loading = true;
        let conds = [
            {
                page: config.pager.currentPage,
                limit: config.pager.pageSize,
                order: config.order,
            },
        ];
        if (config.defaultConds && config.defaultConds.constructor == String) {
            conds.push({ condition: config.defaultConds });
        }
        if (config.defaultConds && Array.isArray(config.defaultConds)) {
            config.defaultConds.filter((a, i) => {
                conds.push(a);
            });
        }
        if (config.conds.date.length > 1) {
            conds.push({
                condition: `${config.option.dateProp || "createtime"
                    } between ${config.conds.date[0]} and ${config.conds.date[1]}`,
            });
        }
        config.conds.searcher.filter((a, i) => {
            console.log('searcher', a);
            conds.push(a);
        });
        config.conds.filter.filter((a, i) => {
            conds.push(a);
        });
        let res = await config.orm.filter({ post: conds });
        config.pager.pageSize = res.pagesize;
        config.pager.total = res.datacount;
        config.pager.currentPage = res.pageindex;
        config.data = res.data;
        // let data = await axios.post(
        //     `/${config.appName}/${config.modelName}/filter`,
        //     conds
        // );
        // config.pager.pageSize = data.data.data.pagesize;
        // config.pager.total = data.data.data.datacount;
        // config.pager.currentPage = data.data.data.pageindex;
        // config.data = data.data.data.data;
        config.loading = false;
    };
    config.onRowDel = async (row, index) => {
        await config.orm.delete({ post: [row] });
        config.refresh();
    };
    config.onRowSave = async (row, done, loading) => {
        loading();
        await config.orm.create({ post: [row] });
        config.refresh();
        done();
    };
    config.onRowUpdate = async (row, index, done, loading) => {
        loading();
        await config.orm.update({ post: [row] });
        config.refresh();
        done();
    };
    config.onSearchChange = async (form, done) => {
        let arr = []
        for (let i of config.option.column) {
            if (form[i.prop] && i.type == "select") {
                arr.push({
                    condition: `${i.prop}='${form[i.prop]}'`,
                });
            }
            if (form[i.prop] && i.type == "tree") {
                arr.push({
                    condition: `${i.prop}='${form[i.prop]}'`,
                });
            }
            if (form[i.prop] && (i.type == "text" || i.type == undefined || i.type == "textarea" || i.type == "input")) {
                let strs = form[i.prop].trim().split(' ');
                let sqls = [];
                for (let s of strs) {
                    if (s)
                        sqls.push(`locate('${s}',\`${i.prop}\`)`)
                }
                arr.push({
                    condition: `(${sqls.join(" and ")})`,
                });
            }
        }
        config.conds.searcher = arr;
        done();
    };
    config.onFilterChange = async (res) => {
        let tmp = [];
        for (let i of res) {
            tmp.push(i);
        }
        config.conds.filter = tmp;
    };
    config.onDateChange = async (range) => {
        let tmp = [];
        if (range) {
            for (let i of range) {
                tmp.push(Date.parse(i));
            }
        }
        config.conds.date = tmp;
    };
    config.onSortChange = async (val) => {
        let order = null;
        if (val.order == "ascending") {
            order = "asc";
        } else if (val.order == "descending") {
            order = "desc";
        }
        config.conds.order = order == null ? null : `${val.prop} ${order}`;
    };
    config.onSelectionChange = async (list) => {
        config.selectedRows = list;
    };

    config.refresh();
    return config;
}
